import styled from 'styled-components'

export const CheckboxListItemStyled = styled.li`
  position: relative;
  display: block;
`
